import { FolderOpenOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

export default function VerifyMeeting() {
  return (
    <div className='text-center'>
      <h2 className='text-lg font-semibold mb-0'>Rendez-vous annulé</h2>
      <FolderOpenOutlined className='text-[56px] my-8' />
      <p className='font-semibold'>Votre rendez-vous a bien été annulé</p>
      <p className='text-xs mb-8' />
      <Link to='/'>
        <Button
          type='primary'
          className='mt-4 !rounded-[32px] !h-10 !font-semibold'
        >
          Accéder à mon espace patient
        </Button>
      </Link>
    </div>
  );
}
